import bubblePop01Url from "./assets/bubble-pop-01.mp3";
import bubblePop02Url from "./assets/bubble-pop-02.mp3";

let audioContext: AudioContext | null = null;
let expandBuffer: AudioBuffer | null = null;
let collapseBuffer: AudioBuffer | null = null;
let isPreloaded = false;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

async function loadAudioBuffer(url: string): Promise<AudioBuffer> {
  const ctx = getAudioContext();
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  return ctx.decodeAudioData(arrayBuffer);
}

export async function preloadBubblePopSounds(): Promise<void> {
  if (isPreloaded) {
    return;
  }

  [expandBuffer, collapseBuffer] = await Promise.all([
    loadAudioBuffer(bubblePop01Url),
    loadAudioBuffer(bubblePop02Url),
  ]);
  isPreloaded = true;
}

function playBuffer(buffer: AudioBuffer | null): void {
  if (!buffer) {
    return;
  }

  const ctx = getAudioContext();

  if (ctx.state === "suspended") {
    ctx.resume();
  }

  const source = ctx.createBufferSource();
  source.buffer = buffer;
  source.connect(ctx.destination);
  source.start(0);
}

export function playExpandPop(): void {
  if (!expandBuffer) {
    preloadBubblePopSounds().then(() => playExpandPop());
    return;
  }
  playBuffer(expandBuffer);
}

export function playCollapsePop(): void {
  if (!collapseBuffer) {
    preloadBubblePopSounds().then(() => playCollapsePop());
    return;
  }
  playBuffer(collapseBuffer);
}
